
export enum SortingColumn {
    STEL = "STEL",
    INITIAL_MARGIN = "INITIAL_MARGIN",
    MARGIN = "MARGIN"
}

export interface SortingDefinition {
    column: SortingColumn;
    ascending: boolean;
}
